import { render, staticRenderFns } from "./AddBeneficiaryReferent.vue?vue&type=template&id=0ef91f2e&"
import script from "./AddBeneficiaryReferent.vue?vue&type=script&lang=js&"
export * from "./AddBeneficiaryReferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports